/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum VsoCluster {
    CLUSTER_1 = "Cluster 1",
    CLUSTER_2 = "Cluster 2",
    CLUSTER_2_EMB = "Cluster 2+EMB",
    CLUSTER_3 = "Cluster 3",
    CLUSTER_3_4 = "Cluster 3/4",
    CLUSTER_4 = "Cluster 4"
}
